import {InventoryActionType, warehouseList} from "../../actions/inventory/inventoryAction";
import commonReducer from "../common/CommonReducer";
import {InboundsActionType} from "../../actions/inbounds/inboundsAction";
import {noop} from "lodash";
import {Create_ASN, Create_Kit} from "../../config";
import api from "../../api/api";
import { v4 as uuidv4 } from 'uuid';


const DefaultInboundsState = {
    inboundsList:[],
    total:0,
    customerList:[]

}

export const inboundsReducer = ( state = DefaultInboundsState, action = {}) =>
{
    switch (action.type) {
        case InboundsActionType.INBOUNDS_SEARCH_LIST:
            return { ...state, inboundsList: action?.payload?.rows?action.payload.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total ? action.payload.total:0}
        case InboundsActionType.CUSTOMER_LIST:

            return { ...state, customerList: action.payload}
        default:
            return state;

    }

}


